import {Component, OnInit, ViewChild} from '@angular/core';
import {AuthService} from '../../../../core/services/auth.service';
import {ToastrService} from 'ngx-toastr';
import i18next from 'i18next';
import {NativeIntegrationService} from '../../../../core/services/native-integration.service';
import {CodeInputComponent} from 'angular-code-input';

@Component({
  selector: 'app-change-pin',
  templateUrl: './change-pin.component.html',
  styleUrls: ['./change-pin.component.scss']
})
export class ChangePinComponent implements OnInit {
  @ViewChild('codeInput') codeInput !: CodeInputComponent;

  constructor(private authService: AuthService,
              private toastr: ToastrService,
              private nativeIntegrationService: NativeIntegrationService,
  ) {
  }

  ngOnInit(): void {
  }

  setPinCompleted(code: string): void {
    console.log('[CHANGE PIN]: Pin changed -> validate Login');

    this.changePin(code);
  }

  changePin(pin: string): void {
    this.codeInput.reset();
    if (this.authService.sessionToken) {
      this.nativeIntegrationService.clientAuth.validateLogin$({
        store: true,
        sessionToken: this.authService.sessionToken,
        useBiometrics: true,
        usePinCode: pin
      }).then(() => {
        this.toastr.success(i18next.t('change-pin.pin-changed'));
        this.nativeIntegrationService.storage.secureStoreSave$(pin, 'pin', false, undefined).then();
      }).catch((error) => {
        console.error(error);
      });
    } else {
      this.toastr.error(i18next.t('change-pin.session-token-missing'));
    }
  }
}
